import React, { useContext } from 'react'
import styled from 'styled-components'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Schedule from '@material-ui/icons/Schedule'
import { updatePortalUser } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import { getAttentionSettings } from '../../overview/components/alert-table-settings'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const Description = styled.p`
  color: #5a5a5a;
  font-size: 1rem;
  margin-bottom: 32px;
  
  span {
    font-family: ${props => props.theme.font.primary};
  }
`

const ThresholdSelect = styled(Select)`
  padding: 7px 12px;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 100px;
  background-color: #eaedf5;
  color: #5a5a5a !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 16px !important;
  font-weight: 300 !important;
  &.Mui-focused .MuiSelect-select {
    background-color: #eaedf5;
  }
  &:before {
    border: none !important;
  }
  &:after {
    border: none !important;
  }
`

const MissedTracking = (props) => {
  const { user, updateUser } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const attentionSettings = getAttentionSettings(user.attention_settings)

  const setMissedTracking = (e) => {
    const value = Number(e.target.value)
    if (attentionSettings.missedtracking !== value) {
      let newSettings = {...attentionSettings}
      newSettings.missedtracking = value
      const newUser = Object.assign({}, user, { attention_settings: newSettings })
      updateUser(newUser)
      updatePortalUser(user.id, { attention_settings: JSON.stringify(newSettings) }).then((res) => {
        openSnackbar('Account was successfully updated.', false)
      }).catch((err) => {
        openSnackbar('There was a problem updating your account.', true)
      })
    }
  }

  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <Schedule /> Missed Tracking
        </Label>
        <Description>
          Here you can adjust the threshold for when a client is considered to have missed tracking.
        </Description>
        <InputLabel id="threshold-select-label" style={{color: '#676767', fontFamily: '"DM Sans", sans-serif', fontSize: '14px', fontWeight: '700', margin: '25px 0 5px 0'}}>Threshold</InputLabel>
        <ThresholdSelect value={attentionSettings.missedtracking} labelId="threshold-select-label" label="Threshold" onChange={setMissedTracking}>
          <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={1}>1 or more missed days</MenuItem>
          <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={2}>2 or more missed days</MenuItem>
          <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={3}>3 or more missed days</MenuItem>
        </ThresholdSelect>
      </Container>
  </React.Fragment>
  )
}

export default MissedTracking